import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../components/question.css";
import RespondentFlowApi from "../services/respondentFlow.api";
import { updateStatus } from "../services/respondent.api";
import * as StatusConstants from "../constants/status.constants";
import { TextField } from "@mui/material";
import LoggerService from "../services/logger.service";
import ClipLoader from "react-spinners/ClipLoader";
import { sessionStore } from "../services/storage.service";

const ProfilerQuesion = () => {
  const [data, setData] = useState([]);
  const [userId, setUserId] = useState(0);
  const [traceId, setTraceId] = useState("");
  const [token, setToken] = useState("");
  const [tokenId, setTokenId] = useState(0);
  const [isSubmitting, setIsSubmitting] = useState(false);
  let navigate = useNavigate();
  const [idx, setIdx] = useState(0);
  const [allData, setAllData] = useState([]);
  const [match, setMatch] = useState(true);
  const [errorIndex, setErrorIndex] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    getQuestions();
    // eslint-disable-next-line
  }, []);

  let getQuestions = async () => {
    try {
      let params = sessionStore.getItem("params");
      let paramObj = JSON.parse(params);
      if (paramObj === null) {
        navigate("/error");
        return;
      }
      setToken(paramObj.token);
      setTokenId(paramObj.tokenId);
      LoggerService.log(
        paramObj.token,
        paramObj.vendorToken ?? "",
        "Getting profiler questions"
      );

      let response = await RespondentFlowApi.post("/v1/profiling", params);

      if (response.questionList.length === 0) {
        LoggerService.log(
          paramObj.token,
          paramObj.vendorToken ?? "",
          "No profiling question received"
        );
        await RespondentFlowApi.post(`/v1/profiling/post-process?token=${token}`, {token: response.token});
        await updateStatus(
          response.token,
          paramObj.tokenId,
          StatusConstants.STATUS_PROFILER_START,
          StatusConstants.SUB_STATUS_PROFILER_TO_SCREENER
        );
        LoggerService.log(
          paramObj.token,
          paramObj.vendorToken ?? "",
          "Redirecting to Router",
          `/st?token=${response.token}`
        );
        navigate(`/st?token=${response.token}`);
        return;
      }

      //TODO:: Remove this code
      let questionList = response.questionList.map((question) => {
        if (question.type === 1 || question.type === 2) {
          question.answerId = [];
        } else {
          question.answerText = null;
        }
        return question;
      });
      LoggerService.log(
        paramObj.token,
        paramObj.vendorToken ?? "",
        "Profiling questions received",
        JSON.stringify(questionList)
      );
      setUserId(response.userId);
      setTraceId(response.traceId);

      setAllData(questionList);
      LoggerService.log(
        paramObj.token,
        paramObj.vendorToken ?? "",
        "Displaying the 1st question " + questionList[0].text,
        JSON.stringify(questionList[0])
      );
    } catch (e) {
      console.log("Error", e);
      navigate("/error");
    }
  };

  let saveRsponse = (event) => {
    event.preventDefault();
    if (errorIndex.length <= 0) {
      setIsLoading(true);
      setIsSubmitting(true);
      let params = sessionStore.getItem("params");
      let paramObj = JSON.parse(params);
      let question = data.length > 0 ? data[0].text : "";
      let reqObj = {};
      reqObj.userId = userId;
      reqObj.responses = data; //TODO:: Remove this code, do checking
      reqObj.traceId = traceId;
      reqObj.token = token;
      reqObj.tokenId = tokenId;
      LoggerService.log(
        token,
        paramObj.vendorToken ?? "",
        "Saving the " + idx + " question - " + question,
        JSON.stringify(reqObj)
      );
      RespondentFlowApi.post(`/v1/profiling/response?token=${token}`, reqObj)
        .then(async (response) => {
          LoggerService.log(
            token,
            paramObj.vendorToken ?? "",
            "User response saved on server",
            JSON.stringify(response)
          );
          if (idx + 1 <= allData.length - 1) {
            LoggerService.log(
              token,
              paramObj.vendorToken ?? "",
              "Displaying next question " + allData[idx + 1].text
            );
            setErrorIndex([]);
            setMatch(true);
            setIdx(idx + 1);
          } else {
            setErrorIndex([]);
            setMatch(true);
            await RespondentFlowApi.post(`/v1/profiling/post-process?token=${token}`, {token: token});
            LoggerService.log(
              token,
              paramObj.vendorToken ?? "",
              "Redirecting to Router",
              `/st?token=${token}`
            );
            
            await updateStatus(
              token,
              tokenId,
              StatusConstants.STATUS_PROFILER_START,
              StatusConstants.SUB_STATUS_PROFILER_TO_SCREENER
            );
            navigate(`/st?token=${token}`);
          }
          setErrorIndex([]);
          setMatch(true);
        })
        .catch(async (e) => {
          LoggerService.log(
            token,
            paramObj.vendorToken ?? "",
            "Error in saving profiler response ",
            JSON.stringify(e)
          );
          navigate(`/error`);
        })
        .finally(() => {
          setIsSubmitting(false);
          setIsLoading(false);
        });
    }
  };

  useEffect(() => {
    let payload = [...allData];
    let slicePayload = payload.slice(idx, idx + 1);
    setData(slicePayload);
  }, [allData, idx]);

 useEffect(() => {
    let indexError = [];
    data.map((value, i) => {
      const minLength = value.min_length ?? 3;
      if (
        value?.answerId?.length === 0 ||
        value?.answerText === null ||
        value?.answerText === "" ||
        (value.id === 59 &&
          (Number(value?.answerText) < 10 || Number(value?.answerText) > 99)) ||
        (value.id === 143 &&
          value?.answerText !== null &&
          value?.answerText !== "" &&
          value?.answerText?.length < minLength)
      ) {
        if (!indexError.includes(i)) {
          indexError.push(i);
        }
      }
      return true;
    });
    setErrorIndex(indexError);
  }, [data]);

  const debounce = (e) => {
    e.preventDefault();
  };

  return (
    <>
      {data.length <= 0 || isLoading ? (
        <div className="flex flex-col items-center justify-center h-screen bg-gray-200">
          <ClipLoader color="#f00" loading={true} size={80} />
        </div>
      ) : (
        <div className="bg-gray-200  h-[100vh] flex justify-center  items-center">
          <div className="questionCard">
            <form
              onSubmit={isSubmitting ? debounce : saveRsponse}
              noValidate
              className="h-[100%] relative"
            >
              <div className="question-body">
                {data.map((value, i) => {

                  return (
                    <div key={i} className="mb-10">
                      <h1 className="question-text">{value?.text}</h1>
                      {value.type === 1 ? (
                        <>
                          {!match && errorIndex.includes(i) && (
                            <div
                              id="example"
                              style={{
                                color: "red",
                                fontSize: "13px",
                                textAlign: "left",
                              }}
                            >
                              This field is required!
                            </div>
                          )}
                          <div
                            className={
                              value?.options.length > 12
                                ? "grid md:grid-cols-2 gap-1 grid-cols-1 mt-2"
                                : "grid md:grid-cols-1 gap-1 grid-cols-1 mt-2"
                            }
                          >
                            {value?.options.map((item, index) => (
                              <label key={index} className={"radio-option"}>
                                <input
                                  type="radio"
                                  id={`radio_${item.id}`}
                                  name={value?.id}
                                  checked={value.answerId.includes(item.id)}
                                  onChange={(e, value) => {
                                    let payload = [...data];
                                    payload[i].answerId = [item.id];

                                    setData(payload);
                                  }}
                                  className="radio-option__input"
                                />
                                <span
                                  className={"radio-option__custom-radio"}
                                ></span>
                                <span className="radio-option__label">
                                  {item?.text}
                                </span>
                              </label>
                            ))}
                          </div>
                          <div className="footer-paading flex flex-row-reverse w-full md:w-[100%] gap-5 h-fit	pt-4 pb-4 bg-white absolute bottom-0">
                            <button
                              type="submit"
                              className="button"
                              onClick={() => {
                                setMatch(false);
                              }}
                            >
                              Next
                            </button>
                          </div>
                        </>
                      ) : value?.type === 4 || value?.type === 3 ? (
                        <div className="mt-2">
                          <TextField
                            size="small"
                            type={value?.type === 4 ? "number" : "text"}
                            autoComplete="off"
                            className="font-medium text-sm"
                            value={
                              value.answerText === null ? "" : value.answerText
                            }
                            onChange={(e) => {
                              const inputValue = e.target.value.trim();

                              if (value.type === 4) {
                                const numValue = Number(inputValue);
                                if (isNaN(numValue) || numValue < 0) return;
                              }
                              setData((prevData) => {
                                const updatedData = [...prevData];
                                updatedData[i].answerText = inputValue;
                                return updatedData;
                              });
                            }}
                            error={errorIndex.includes(i) ? true : false}
                          />

                          {!match && errorIndex.includes(i) && (
                            <div
                              style={{
                                color: "red",
                                marginTop: "5px",
                                fontSize: "13px",
                                textAlign: "left",
                              }}
                            >
                              {value.id === 59
                                ? Number(value.answerText) > 99
                                  ? "Age should not be greater than 100."
                                  : Number(value.answerText) < 10
                                  ? "Age should not be less than 10."
                                  : "This field is required!"
                                : value.id === 143 &&
                                  value?.answerText?.length > 0 &&
                                  value?.answerText?.length < (value.min_length ?? 3)
                                ? `Must be at least ${value.min_length ?? 3} characters.`
                                : "This field is required!"}
                            </div>
                          )}
                        </div>
                      ) : (
                        <>
                          {!match && errorIndex.includes(i) && (
                            <div
                              style={{
                                color: "red",
                                fontSize: "13px",
                                textAlign: "left",
                              }}
                            >
                              This field is required!
                            </div>
                          )}
                          <div
                            className={
                              value?.options.length > 12
                                ? "grid md:grid-cols-2 gap-1 grid-cols-1 mt-2"
                                : "grid md:grid-cols-1 gap-1 grid-cols-1 mt-2"
                            }
                          >
                            {value?.options.map((item, index) => {
                              return (
                                <label
                                  key={index}
                                  className={"input-checkmark"}
                                >
                                  <input
                                    type="checkbox"
                                    id={`checkbox_${item.id}`}
                                    name={value?.id}
                                    checked={value.answerId.includes(item.id)}
                                    onChange={(e, value) => {
                                      let payload = [...data];
                                      if (!e.target.checked) {
                                        payload[i].answerId = payload[
                                          i
                                        ].answerId.filter(
                                          (answer) => answer !== item.id
                                        );
                                      } else {
                                        payload[i].answerId.push(item.id);
                                      }
                                      setData(payload);
                                    }}
                                  />
                                  <span className={"checkmark"}></span>
                                  <span className="radio-option__label">
                                    {item?.text}
                                  </span>
                                </label>
                              );
                            })}
                          </div>
                        </>
                      )}
                    </div>
                  );
                })}
              </div>
              <div className="footer-paading flex flex-row-reverse w-full md:w-[100%]  gap-5 h-fit	pt-4 pb-4 bg-white absolute bottom-0">
                <button
                  disabled={isSubmitting}
                  type="submit"
                  className="button"
                  onClick={() => {
                    setMatch(false);
                  }}
                >
                  Next
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default ProfilerQuesion;